/** @jsx h */
import { h } from 'preact'

const EnvironmentalImpact = () => (
  <svg width={28} height={32}>
    <g fill='none' fillRule='evenodd' stroke='#2F3A4A'>
      <path
        strokeDasharray='1 2'
        d='M16.5 20c.459-2.352 2.5-6 5-6M27 4c-2.005 5.102-4.5 4-10.209 7.649-1.654 1.057-2.09 3.7-2.046 6.392M17 22c10.944-3.855 10-9 10-14'
      />
      <path d='M13 24c-7 0-10-4.5-11-7-1.082-2.705-1-7-1-7 2.132 3.54 5.5 2.5 10 6s6 10 6 10-3.5-7-9-7' />
    </g>
  </svg>
)

export default EnvironmentalImpact
